export function isMessageDetailReady(loading, feedback) {
  return Boolean(!loading && feedback?.id && feedback?.item);
}

export function shouldFetchMessageDetail(isOpen, feedbackId) {
  return Boolean(isOpen && feedbackId);
}
